var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewSliderChevronRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "next",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#dddfe1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3596",
    "data-name": "Path 3596",
    d: "M15649.285-6285.741a.826.826,0,0,1-.239-.582.827.827,0,0,1,.239-.582l2.849-2.848-2.849-2.848a.817.817,0,0,1-.239-.578.82.82,0,0,1,.239-.582.82.82,0,0,1,1.163,0l3.426,3.426a.814.814,0,0,1,.243.582.807.807,0,0,1-.243.582l-3.426,3.43a.827.827,0,0,1-.583.239A.817.817,0,0,1,15649.285-6285.741Z",
    transform: "translate(-15639.58 6301.751)",
    fill: "#707070"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSliderChevronRight);
export default __webpack_public_path__ + "static/media/NewSliderChevronRight.fbb7c59329a4c5c440ae7f9a5ab9539b.svg";
export { ForwardRef as ReactComponent };